import React from "react";
import PropTypes from "prop-types";
import "./Loader.css";
import { Container } from "../../layout";

/**
 * Composant `Loader` pour afficher un indicateur de chargement stylisé.
 *
 * @param {string} color - Couleur des anneaux (CSS color value). Défaut : 'var(--c-default)'.
 * @param {string} size - Taille des anneaux, valeurs possibles : 'sm', 'md', 'lg'. Défaut : 'md'.
 * @param {string} name - Nom du loader pour identification. Défaut : ''.
 * @param {object} props - Autres propriétés à passer au composant.
 * @returns {JSX.Element} Un élément `<div>` représentant un loader.
 */
const Loader = ({
  color = "var(--c-default)",
  size = "md",
  name = "",
  ...props
}) => {
  const sizeMap = {
    sm: 18,
    md: 30,
    lg: 50,
  };

  const sizeValue = sizeMap[size] || sizeMap.md;

  return (
    <Container
      className="Loader"
      style={{ width: sizeValue, height: sizeValue }}
      aria-label={name}
      {...props}
    >
      <Container
        className="lds-ring"
        style={{ width: sizeValue, height: sizeValue }}
      >
        <Container
          style={{
            borderColor: `${color} transparent transparent transparent`,
            borderWidth: sizeValue / 12,
            width: sizeValue,
            height: sizeValue,
          }}
        ></Container>
        <Container
          style={{
            borderColor: `${color} transparent transparent transparent`,
            borderWidth: sizeValue / 12,
            width: sizeValue,
            height: sizeValue,
          }}
        ></Container>
        <Container
          style={{
            borderColor: `${color} transparent transparent transparent`,
            borderWidth: sizeValue / 12,
            width: sizeValue,
            height: sizeValue,
          }}
        ></Container>
        <Container
          style={{
            borderColor: `${color} transparent transparent transparent`,
            borderWidth: sizeValue / 12,
            width: sizeValue,
            height: sizeValue,
          }}
        ></Container>
      </Container>
    </Container>
  );
};

Loader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  name: PropTypes.string,
  props: PropTypes.object,
};

export default Loader;
